import {Component, Input, forwardRef} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NgbDate, NgbDateStruct, NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';

const DATETIME_EDIT_CONTROL_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TmwDatetimeEditComponent),
};

const noop = (): void => {};

@Component({
  selector: 'tmw-datetime-edit',
  standalone: true,
  template: `<div class="input-group">
    <input
      class="form-control"
      placeholder="yyyy-mm-dd"
      name="dp"
      (dateSelect)="update($event)"
      [(ngModel)]="_value"
      ngbDatepicker
      #d="ngbDatepicker"
      (change)="update(_value)"
      [disabled]="_disabled"
      [readOnly]="readOnly"
      [maxDate]="maxDate!"
      style="background-color: rgba(1, 89, 154, 0.15);"
    />
    <button
      style="background-color: rgba(1, 89, 154, 0.15);"
      class="btn btn-outline-secondary bi bi-calendar3"
      (click)="d.toggle()"
      type="button"
    ></button>
  </div>`,
  imports: [NgbDatepickerModule, FormsModule],
  providers: [DATETIME_EDIT_CONTROL_VALUE_ACCESSOR],
})
export class TmwDatetimeEditComponent implements ControlValueAccessor {
  _value?: any;
  _disabled: boolean = false;
  @Input() maxDate: NgbDateStruct | undefined;
  @Input() readOnly: boolean = false;

  private onTouched: () => void = noop;
  private onChange: (_: any) => void = noop;

  update($event: NgbDate | undefined) {
    this._value = $event;
    let val = this.toModel();
    this.onTouched();
    this.onChange(val);
    this.onChange(val);
  }

  fromModel(raw: any): NgbDateStruct | undefined {
    let result = undefined;
    if (raw) {
      let day = dayjs(raw);
      result = {day: day.date(), month: day.month() + 1, year: day.year()};
    }
    return result;
  }

  toModel() {
    let result = null;
    if (this._value) {
      if (this._value.length) {
        let parts = this._value.split('/');
        if (parts.length == 3) {
          result = dayjs(new Date(+parts[2], +parts[1] - 1, +parts[0], 11)).toISOString();
        } else {
          result = undefined;
        }
      } else {
        result = dayjs(new Date(this._value.year, this._value.month - 1, this._value.day, 11)).toISOString();
      }
    } else {
      result = undefined;
    }
    return result;
  }

  writeValue(day: any): void {
    this._value = this.fromModel(day);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }
}
